import { Box, Typography } from '@mui/material';
import noResults from '../../../assets/images/no-results.png';

const NoResultsPublished = () => {
    return (
        <div>
            <Box className="ty_pr_tabs_no_results">
                <img src={noResults}
                    style={{
                        width: "80px",
                        maxWidth: "100%",
                        objectFit: "contain",
                    }}
                    alt="no results" />
                <Box>
                    <Typography
                        variant="h4"
                        className="ty_form_heading"
                        sx={{ textAlign: "center" }}
                    >
                        No Results Published
                    </Typography>
                    <p>Results have not been published yet. Please check back later.</p>
                </Box>
            </Box>
        </div>
    )
}

export default NoResultsPublished
